import { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import { API_URL } from "../constant/constant";

const CategoryIconContext = createContext({});

export function CategoryIconProvider({ children }) {
  const [iconMap, setIconMap] = useState(() => {
    // Hydrate from localStorage on mount (instant, no flash)
    if (typeof window !== "undefined") {
      const cached = localStorage.getItem("categoryIconsMap");
      return cached ? JSON.parse(cached) : {};
    }
    return {};
  });

  useEffect(() => {
    let cancelled = false;
    axiosInstance
      .get(`${API_URL.BASE_VENDOR}/rest/big-local/api/v1/vendor/category/icons`)
      .then((res) => {
        if (!cancelled) {
          setIconMap(res.data);
          localStorage.setItem("categoryIconsMap", JSON.stringify(res.data));
        }
      })
      .catch((error) => {
        console.error("Error fetching category icons:", error);
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <CategoryIconContext.Provider value={iconMap}>
      {children}
    </CategoryIconContext.Provider>
  );
}

export function useCategoryIcons() {
  const iconMap = useContext(CategoryIconContext);
  return (name) => {
    if (!name) return "";
    return iconMap[name] || ""; // no fallback to local files
  };
}
